module.exports = __webpack_public_path__ + "static/media/ZA.46699eea.svg";